import { injectable } from 'inversify';
import { INotificationMessage } from '../../../interfaces';
import { INotificationsResolveAdapterService } from './notifications-resolve-adapter.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class NotificationsResolveAdapterMock implements INotificationsResolveAdapterService {
    notificationsObs(): Observable<Array<INotificationMessage>> {
        return NEVER;
    }
    resolveNotifications = (): Promise<Array<INotificationMessage>> =>
        Promise.resolve([]);
}
